<template>
  <el-row class="jom-main-content">
    <div class="jom-refer-layer"></div>
    <jobody></jobody>
  </el-row>
</template>

<script>
  /* eslint-disable */
  import jobody from "./body/body";

  export default {
    components: {
      jobody,
    },
    data() {
      return {
        height: 0
      }
    },
    mounted() {
      MathJax.Hub.Queue(["Typeset", MathJax.Hub]);

      //禁止折行
      this.enchanceNoBreak()
    },
    methods: {
      enchanceNoBreak() {
        let documentWidth = document.documentElement.clientWidth - 60;
        let supList = document.querySelectorAll(".jom-sup");
        for (let i in supList) {
          let node = supList[i]
          if (node.offsetWidth >= documentWidth){
            continue;
          }
          let canSplit = true
          while (!node.previousSibling && node.parentNode) {
            node = node.parentNode
            if (node.tagName == "P" || node.tagName == "TD" || node.tagName == "TH" || node.tagName == "DIV") {
              canSplit = false
              break
            }
          }
          if (!canSplit || node.parentNode && node.parentNode.tagName == "NOBR") {
            continue
          }
          if (!node.previousSibling || node.previousSibling.textContent.length==0) {
            continue
          }
          if (node.previousSibling.className) {
            if (node.previousSibling.className.indexOf("jom-vocab") > -1 ||
                node.previousSibling.className.indexOf("jom-inlineformula") > -1) {
              continue
            }
          }

          if (node.previousSibling.tagName == "NOBR") {
            node.previousSibling.appendChild(node)
          }
          else {
            let splitedNode = node.previousSibling.cloneNode(false)
            if (this.splitNode(node.previousSibling, splitedNode)) {
              let nobrNode = document.createElement("nobr")
              node.parentNode.insertBefore(nobrNode, node)
              nobrNode.appendChild(splitedNode)
              nobrNode.appendChild(node)
            }
          }
        }
      },
      splitNode(node, splitedNode) {
        if (node.nodeName === "#text") {
          if (node.textContent.length == 1) {
            splitedNode = node.textContent
            if (node.parentNode.childNodes.length == 1) {
              node.parentNode.parentNode.removeChild(node.parentNode)
            } else {
              node.parentNode.removeChild(node)
            }
            return true
          } else if (node.textContent.length > 1) {
            let lastText = node.textContent.substring(node.textContent.length-1, node.textContent.length)
            splitedNode.textContent = lastText
            node.textContent = node.textContent.substring(0, node.textContent.length-1)
            return true
          } else {
            return false;
          }
        } else {
          if (node.childNodes.length > 0) {
            let splitedChildNode = node.lastChild.cloneNode(false)
            splitedNode.appendChild(splitedChildNode)
            return this.splitNode(node.lastChild, splitedChildNode)
          } else {
            return false
          }
        }
      }
    }
  }
</script>

<style>
  .jom-refer-layer {
    width: calc(100% - 3px);
    height: 16px;
    background-color: #fafafa;
    border-left: 3px solid #00a2af;
  }

  .jom-main-content {
    position: relative;
    text-align: justify;
  }
</style>




// WEBPACK FOOTER //
// src/componentsMobile/maincontent/maincontent.vue